import {
  FETCH_INVENTORIES,
  FETCH_INVENTORIED_ITEMS,
  FETCH_INVENTORIED_ITEMS_CSV,
  FETCH_SHIPMENT_REPORT,
  FETCH_INVOICE_REPORT,
  FETCH_INVOICE_REPORT_CSV,
  FETCH_PRODUCTION_REPORT,
  FETCH_INVENTORY_WASTE_REPORT,
  FETCH_INVENTORY_WASTE_REPORT_CSV,
  FETCH_YIELD_REPORT,
  FETCH_YIELD_REPORT_CSV,
  FETCH_AVERAGE_YIELD,
  FETCH_EXPIRED_INVENTORIES_REPORT,
  FETCH_EXPIRED_INVENTORIES_REPORT_CSV,
  FETCH_WEIGHTED_PRICE_REPORT,
  FETCH_WEIGHTED_PRICE_REPORT_CSV,
  FETCH_RECEIVING_REPORT,
} from "./types";

import { ITEMS_PER_PAGE } from "../../constants/constants";

const INITIAL_STATE = {
  inventoryList: {
    inventories: [],
    pages: undefined,
    error: null,
    loading: true,
  },
  inventoriedItemsList: {
    inventories: [],
    pages: undefined,
    error: null,
    loading: true,
  },
  inventoriedItemsCSV: {
    itemsCSV: [],
    error: null,
    loading: true,
  },
  shipmentReport: {
    shipments: [],
    pages: undefined,
    error: null,
    loading: false,
  },
  invoicesReport: {
    invoices: [],
    invoicesCSV: [],
    error: null,
    loading: false,
  },
  invoiceReportCSV: {
    invoiceCSV: [],
    invoiceCSV_R: [],
    error: null,
    loading: false,
  },
  productionReport: {
    production: [],
    pages: undefined,
    error: null,
    loading: false,
  },
  inventoryWasteReport: {
    wasteReport: [],
    pages: undefined,
    error: null,
    loading: false,
  },
  inventoryWasteReportCSV: {
    wasteCSV: [],
    error: null,
    loading: false,
  },
  yieldReport: {
    report: [],
    pages: undefined,
    error: null,
    loading: false,
  },
  yieldReportCSV: {
    yieldCSV: [],
    error: null,
    loading: false,
  },
  avgYield: {
    value: undefined,
    error: null,
    loading: false,
  },
  expiredInventoriesReport: {
    expiredReport: [],
    pages: undefined,
    error: null,
    loading: false,
  },
  expiredInventoriesReportCSV: {
    expiredCSV: [],
    error: null,
    loading: false,
  },
  weightedPrices: {
    list: [],
    loading: undefined,
    error: undefined,
  },
  weightedPricesCSV: {
    csv: [],
    error: null,
    loading: false,
  },
  receivingReport: {
    receivingReports: [],
    pages: undefined,
    error: null,
    loading: false,
  },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // --------------------------------------------------------------------------
    // FETCH_INVENTORIES
    // --------------------------------------------------------------------------
    case FETCH_INVENTORIES.init:
      return {
        ...state,
        inventoryList: { ...state.inventoryList, error: null, loading: true },
      };
    case FETCH_INVENTORIES.success:
      return {
        ...state,
        inventoryList: {
          ...state.inventoryList,
          inventories: action.payload,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_INVENTORIES.failure:
      return {
        ...state,
        inventoryList: {
          ...state.inventoryList,
          inventories: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_INVENTORIED_ITEMS
    // --------------------------------------------------------------------------
    case FETCH_INVENTORIED_ITEMS.init:
      return {
        ...state,
        inventoriedItemsList: {
          ...state.inventoriedItemsList,
          error: null,
          loading: true,
        },
      };
    case FETCH_INVENTORIED_ITEMS.success:
      return {
        ...state,
        inventoriedItemsList: {
          ...state.inventoriedItemsList,
          inventories: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_INVENTORIED_ITEMS.failure:
      return {
        ...state,
        inventoriedItemsList: {
          ...state.inventoriedItemsList,
          inventories: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_INVENTORIED_ITEMS_CSV
    // --------------------------------------------------------------------------
    case FETCH_INVENTORIED_ITEMS_CSV.init:
      return {
        ...state,
        inventoriedItemsCSV: {
          ...state.inventoriedItemsCSV,
          error: null,
          loading: true,
        },
      };
    case FETCH_INVENTORIED_ITEMS_CSV.success:
      return {
        ...state,
        inventoriedItemsCSV: {
          ...state.inventoriedItemsCSV,
          itemsCSV: action.payload,
          error: null,
          loading: false,
        },
      };
    case FETCH_INVENTORIED_ITEMS_CSV.failure:
      return {
        ...state,
        inventoriedItemsCSV: {
          ...state.inventoriedItemsCSV,
          itemsCSV: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_SHIPMENT_REPORT
    // --------------------------------------------------------------------------
    case FETCH_SHIPMENT_REPORT.init:
      return {
        ...state,
        shipmentReport: {
          ...state.shipmentReport,
          pages: undefined,
          error: null,
          loading: true,
        },
      };
    case FETCH_SHIPMENT_REPORT.success:
      return {
        ...state,
        shipmentReport: {
          ...state.shipmentReport,
          shipments: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_SHIPMENT_REPORT.failure:
      return {
        ...state,
        shipmentReport: {
          ...state.shipmentReport,
          shipments: [],
          pages: undefined,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_INVOICE_REPORT
    // --------------------------------------------------------------------------
    case FETCH_INVOICE_REPORT.init:
      return {
        ...state,
        invoicesReport: { ...state.invoicesReport, error: null, loading: true },
      };
    case FETCH_INVOICE_REPORT.success:
      return {
        ...state,
        invoicesReport: {
          ...state.invoicesReport,
          invoices: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_INVOICE_REPORT.failure:
      return {
        ...state,
        invoicesReport: {
          ...state.invoicesReport,
          invoices: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_INVOICE_REPORT_CSV
    // --------------------------------------------------------------------------
    case FETCH_INVOICE_REPORT_CSV.init:
      return {
        ...state,
        invoiceReportCSV: {
          ...state.invoiceReportCSV,
          error: null,
          loading: true,
        },
      };
    case FETCH_INVOICE_REPORT_CSV.success:
      /* Json is converted to array to preserve order */
      return {
        ...state,
        invoiceReportCSV: {
          ...state.invoiceReportCSV,
          invoiceCSV: action.payload.map((e) => {
            return [
              e["vendor_name"],
              e["due_date"],
              e["invoice_number"],
              e["date"],
              e["item_description"],
              e["cost"],
              e["pack"],
              e["quantity"],
              e["total_quantity"],
              e["net_weight"],
              e["total_price"],
            ];
          }),
          invoiceCSV_R: action.payload.map((e) => {
            return [
              e["vendor_name"],
              "112",
              e["invoice_number"],
              e["date"],
              e["receiving_id_R365"],
              e["description_R365"],
              e["measure_unit"],
              e["total_quantity"],
              e["cost"],
              e["total_price"],
            ];
          }),
          error: null,
          loading: false,
        },
      };
    case FETCH_INVOICE_REPORT_CSV.failure:
      return {
        ...state,
        invoiceReportCSV: {
          ...state.invoiceReportCSV,
          invoiceCSV: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_PRODUCTION_REPORT
    // --------------------------------------------------------------------------
    case FETCH_PRODUCTION_REPORT.init:
      return {
        ...state,
        productionReport: {
          ...state.productionReport,
          error: null,
          pages: undefined,
          loading: true,
        },
      };
    case FETCH_PRODUCTION_REPORT.success:
      return {
        ...state,
        productionReport: {
          ...state.productionReport,
          production: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_PRODUCTION_REPORT.failure:
      return {
        ...state,
        productionReport: {
          ...state.productionReport,
          production: [],
          pages: undefined,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_INVENTORY_WASTE_REPORT
    // --------------------------------------------------------------------------
    case FETCH_INVENTORY_WASTE_REPORT.init:
      return {
        ...state,
        inventoryWasteReport: {
          ...state.inventoryWasteReport,
          pages: undefined,
          error: null,
          loading: true,
        },
      };
    case FETCH_INVENTORY_WASTE_REPORT.success:
      return {
        ...state,
        inventoryWasteReport: {
          ...state.inventoryWasteReport,
          wasteReport: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_INVENTORY_WASTE_REPORT.failure:
      return {
        ...state,
        inventoryWasteReport: {
          ...state.inventoryWasteReport,
          wasteReport: [],
          pages: undefined,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_INVENTORY_WASTE_REPORT_CSV
    // --------------------------------------------------------------------------
    case FETCH_INVENTORY_WASTE_REPORT_CSV.init:
      return {
        ...state,
        inventoryWasteReportCSV: {
          ...state.inventoryWasteReportCSV,
          error: null,
          loading: true,
        },
      };
    case FETCH_INVENTORY_WASTE_REPORT_CSV.success:
      return {
        ...state,
        inventoryWasteReportCSV: {
          ...state.inventoryWasteReportCSV,
          wasteCSV: action.payload.map((e) => {
            return Object.values(e);
          }),
          error: null,
          loading: false,
        },
      };
    case FETCH_INVENTORY_WASTE_REPORT_CSV.failure:
      return {
        ...state,
        inventoryWasteReportCSV: {
          ...state.inventoryWasteReportCSV,
          wasteCSV: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_YIELD_REPORT
    // --------------------------------------------------------------------------
    case FETCH_YIELD_REPORT.init:
      return {
        ...state,
        yieldReport: {
          ...state.yieldReport,
          pages: undefined,
          error: null,
          loading: true,
        },
      };
    case FETCH_YIELD_REPORT.success:
      return {
        ...state,
        yieldReport: {
          ...state.yieldReport,
          report: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_YIELD_REPORT.failure:
      return {
        ...state,
        yieldReport: {
          ...state.yieldReport,
          report: [],
          pages: undefined,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_YIELD_REPORT_CSV
    // --------------------------------------------------------------------------
    case FETCH_YIELD_REPORT_CSV.init:
      return {
        ...state,
        yieldReportCSV: { ...state.yieldReportCSV, error: null, loading: true },
      };
    case FETCH_YIELD_REPORT_CSV.success:
      return {
        ...state,
        yieldReportCSV: {
          ...state.yieldReportCSV,
          yieldCSV: action.payload.map((e) => Object.values(e)),
          error: null,
          loading: false,
        },
      };
    case FETCH_YIELD_REPORT_CSV.failure:
      return {
        ...state,
        yieldReportCSV: {
          ...state.yieldReportCSV,
          yieldCSV: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_AVERAGE_YIELD
    // --------------------------------------------------------------------------
    case FETCH_AVERAGE_YIELD.init:
      return {
        ...state,
        avgYield: { ...state.avgYield, error: null, loading: true },
      };
    case FETCH_AVERAGE_YIELD.success:
      return {
        ...state,
        avgYield: {
          ...state.avgYield,
          value: action.payload,
          error: null,
          loading: false,
        },
      };
    case FETCH_AVERAGE_YIELD.failure:
      return {
        ...state,
        avgYield: {
          ...state.avgYield,
          value: undefined,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_EXPIRED_INVENTORIES_REPORT
    // --------------------------------------------------------------------------
    case FETCH_EXPIRED_INVENTORIES_REPORT.init:
      return {
        ...state,
        expiredInventoriesReport: {
          ...state.expiredInventoriesReport,
          pages: undefined,
          error: null,
          loading: true,
        },
      };
    case FETCH_EXPIRED_INVENTORIES_REPORT.success:
      return {
        ...state,
        expiredInventoriesReport: {
          ...state.expiredInventoriesReport,
          expiredReport: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_EXPIRED_INVENTORIES_REPORT.failure:
      return {
        ...state,
        expiredInventoriesReport: {
          ...state.expiredInventoriesReport,
          expiredReport: [],
          pages: undefined,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_EXPIRED_INVENTORIES_REPORT_CSV
    // --------------------------------------------------------------------------
    case FETCH_EXPIRED_INVENTORIES_REPORT_CSV.init:
      return {
        ...state,
        expiredInventoriesReportCSV: {
          ...state.expiredInventoriesReportCSV,
          error: null,
          loading: true,
        },
      };
    case FETCH_EXPIRED_INVENTORIES_REPORT_CSV.success:
      return {
        ...state,
        expiredInventoriesReportCSV: {
          ...state.expiredInventoriesReportCSV,
          expiredCSV: action.payload.map((e) => Object.values(e)),
          error: null,
          loading: false,
        },
      };
    case FETCH_EXPIRED_INVENTORIES_REPORT_CSV.failure:
      return {
        ...state,
        expiredInventoriesReportCSV: {
          ...state.expiredInventoriesReportCSV,
          expiredCSV: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_WEIGHTED_PRICE_REPORT
    // --------------------------------------------------------------------------
    case FETCH_WEIGHTED_PRICE_REPORT.init:
      return {
        ...state,
        weightedPrices: { ...state.weightedPrices, list: [], loading: true },
      };
    case FETCH_WEIGHTED_PRICE_REPORT.success:
      return {
        ...state,
        weightedPrices: {
          list: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_WEIGHTED_PRICE_REPORT.failure:
      return {
        ...state,
        weightedPrices: {
          ...state.weightedPrices,
          list: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_WEIGHTED_PRICE_REPORT_CSV
    // --------------------------------------------------------------------------
    case FETCH_WEIGHTED_PRICE_REPORT_CSV.init:
      return {
        ...state,
        weightedPricesCSV: {
          ...state.weightedPricesCSV,
          error: null,
          loading: true,
        },
      };
    case FETCH_WEIGHTED_PRICE_REPORT_CSV.success:
      /* Json is converted to array to preserve order */
      return {
        ...state,
        weightedPricesCSV: {
          ...state.weightedPricesCSV,
          csv: action.payload.map((e) => {
            return [
              e["item_name"],
              e["item_brand"],
              e["item_brand_grade"]
                .replace(e["item_name"], "")
                .replace(e["item_brand"], "")
                .replace(/^\s+|\s+$/g, ""),
              e["total_weight"],
              e["weighted_price_avg"],
            ];
          }),
          error: null,
          loading: false,
        },
      };
    case FETCH_WEIGHTED_PRICE_REPORT_CSV.failure:
      return {
        ...state,
        weightedPricesCSV: {
          ...state.weightedPricesCSV,
          csv: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_RECEIVING_REPORT
    // --------------------------------------------------------------------------
    case FETCH_RECEIVING_REPORT.init:
      return {
        ...state,
        receivingReport: {
          ...state.receivingReport,
          pages: undefined,
          error: null,
          loading: true,
        },
      };
    case FETCH_RECEIVING_REPORT.success:
      return {
        ...state,
        receivingReport: {
          ...state.receivingReport,
          receivingReports: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_RECEIVING_REPORT.failure:
      return {
        ...state,
        receivingReport: {
          ...state.receivingReport,
          receivingReports: [],
          pages: undefined,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    default:
      return state;
  }
};
